import {
  PutDataParams,
  uploadAction,
  UploadActionTypes,
} from "../../types/upload";
import { Dispatch } from "react";
import http from "../../utils/http-common";
import { NotificationSend } from "../../utils/Notification/Notification";

export const uploadFile = (
  formData: FormData,
  onUploadProgress: (progressEvent: { loaded: number; total: number }) => void
) => {
  return async (dispatch: Dispatch<uploadAction>): Promise<void> => {
    try {
      dispatch({
        type: UploadActionTypes.UPLOAD_FILE,
      });

      const response = await http.post(`/api/v0.1/upload`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        onUploadProgress,
      });
      dispatch({
        type: UploadActionTypes.UPLOAD_FILE_SUCCESS,
        payload: response.data,
      });
    } catch (e) {
      NotificationSend("error", "Ошибка загрузки файла: " + e);
      dispatch({
        type: UploadActionTypes.UPLOAD_FILE_ERROR,
        payload: "Произошла ошибка при загрузке файла",
      });
    }
  };
};

export function removeSequence(
  sequence: string,
  uuid: string,
  sequences: string[]
): uploadAction {
  return {
    type: UploadActionTypes.REMOVE_SEQUENCE,
    payload: {
      uuid: uuid,
      sequences: sequences.filter((t) => t !== sequence),
    },
  };
}

export const putUploadData = (data: PutDataParams) => {
  return async (dispatch: Dispatch<uploadAction>): Promise<void> => {
    try {
      dispatch({
        type: UploadActionTypes.PUT_UPLOAD_DATA,
      });

      await http.put(`/api/v0.1/upload`, data);
      dispatch({
        type: UploadActionTypes.PUT_UPLOAD_DATA_SUCCESS,
      });
      NotificationSend("success", "Данные отрпалвены");
    } catch (e) {
      NotificationSend("error", "Ошибка отправки данных: " + e);
      dispatch({
        type: UploadActionTypes.PUT_UPLOAD_DATA_ERROR,
        payload: "Произошла ошибка при отправке данных",
      });
    }
  };
};
